<script setup lang="ts">
  import { useRouter } from "vue-router";
  import {
    Text,
    RadioButton,
    useTheme,
    IconArrowLeft,
    IconLanguageRU,
    IconLanguageEN,
    useLanguage,
    IconThemeMobileLight,
    IconThemeMobileDark,
    IconThemeMobileSystem,
  } from "@ui-kit";
  import { StatusBar, TopBar } from "@src/components";

  const { back } = useRouter();
  const { currentTheme, setThemeLight, setThemeDark, setThemeSystem } = useTheme();
  const { currentLanguage, setLanguageEn, setLanguageRu } = useLanguage();
</script>

<template>
  <div class="settings-page" data-testid="settings-page">
    <StatusBar />
    <TopBar :title="$t('Настройки приложения')" @click:left="back">
      <template #left>
        <IconArrowLeft />
      </template>
    </TopBar>
    <div class="settings-page__content">
      <div class="settings-page__section">
        <Text font="body-medium-18">{{ $t("Тема") }}</Text>
        <div class="settings-page__section-theme">
          <div class="settings-page__theme-item" @click="setThemeLight" data-testid="settings-page-theme-light">
            <IconThemeMobileLight />
            <Text font="body-regular-14">{{ $t("Светлая") }}</Text>
            <RadioButton value="light" :is-checked="currentTheme === 'light'" data-testid="settings-page-theme-light-radio" />
          </div>
          <div class="settings-page__theme-item" @click="setThemeDark" data-testid="settings-page-theme-dark">
            <IconThemeMobileDark />
            <Text font="body-regular-14">{{ $t("Темная") }}</Text>
            <RadioButton value="dark" :is-checked="currentTheme === 'dark'" data-testid="settings-page-theme-dark-radio" />
          </div>
          <div class="settings-page__theme-item" @click="setThemeSystem" data-testid="settings-page-theme-system">
            <IconThemeMobileSystem />
            <Text font="body-regular-14">{{ $t("Как в системе") }}</Text>
            <RadioButton value="system" :is-checked="currentTheme === 'system'" data-testid="settings-page-theme-system-radio" />
          </div>
        </div>
      </div>
      <div class="settings-page__section">
        <Text font="body-medium-18">{{ $t("Язык") }}</Text>
        <div class="settings-page__section-language">
          <div class="settings-page__language-item" @click="setLanguageRu" data-testid="settings-page-lang-ru">
            <IconLanguageRU />
            <Text font="body-regular-16">Русский</Text>
            <RadioButton value="ru" :is-checked="currentLanguage === 'ru'" data-testid="settings-page-lang-ru-radio" />
          </div>
          <div class="settings-page__language-item" @click="setLanguageEn" data-testid="settings-page-lang-en">
            <IconLanguageEN />
            <Text font="body-regular-16">Английский</Text>
            <RadioButton value="en" :is-checked="currentLanguage === 'en'" data-testid="settings-page-lang-en-radio" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .settings-page {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: var(--sf-base-background-primary);
  }

  .settings-page__content {
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
  }

  .settings-page__section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .settings-page__section-theme {
    display: flex;
    padding: 16px 4px;
  }

  .settings-page__section-language {
    padding: 4px 4px;
  }

  .settings-page__section-theme,
  .settings-page__section-language {
    border-radius: 16px;
    background-color: var(--sf-base-background-white);
  }

  .settings-page__theme-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  .settings-page__theme-item :deep(.text) {
    margin-top: 12px;
    margin-bottom: 8px;
  }

  .settings-page__section :deep(.radio-btn) {
    height: 20px;
    width: 20px;
  }

  .settings-page__language-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
  }

  .settings-page__language-item :deep(.text) {
    flex: 1;
  }
</style>
